import { createContext } from "react"
import { ImageBody } from "../api"

export type GalleryPreviewContextType = {
  currentImageIndex: {id: number, url: string} | undefined,
  setCurrentImage: (currImage: { id: number, url: string } | undefined) => void
  setImages: (arr:ImageBody[]) => void,
  nextImage: () => void,
  prevImage: () => void,
  openPreview: boolean,
  setOpenPreview: (val: boolean) => void
}



export const GalleryPreviewContext = createContext<GalleryPreviewContextType>({
  currentImageIndex: undefined,
  setCurrentImage: ()=>{},
  setImages: () => {},
  nextImage: () => {},
  prevImage: () => {},
  openPreview: false,
  setOpenPreview: () => {}
})

